// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1o54H","insightsList":"newBusinessInsightsMenu_insightsList__20BBm","active":"newBusinessInsightsMenu_active__1SBe4"};